import { useState } from "react";
function useRootProps(props) {
  const [rootRef, setRootRef] = useState(() => null);
  const { testId = "TidalDurationInput", className = "", sx, slotProps } = props;
  const rootProps = {
    ...slotProps?.root,
    className,
    // @ts-expect-error
    "data-testid": testId,
    "data-tidal": "DurationInput",
    sx,
    ref: setRootRef
  };
  return {
    rootProps,
    rootRef
  };
}
export {
  useRootProps
};
//# sourceMappingURL=useRootProps.js.map
